// extracted by extract-css-chunks-webpack-plugin
module.exports = {"img":"_2C5hP7","card":"_2m7-A-"};